module.exports = __webpack_public_path__ + "static/media/sravani.f7126540.webp";